import FadeOverlay from '@components/FadeOverlay'
import contextArticleTextbox from '@contexts/articleTextbox'
import { FunctionComponent, useContext } from 'react'

const { ArticleTextboxContext } = contextArticleTextbox

const TextboxFadeOverlay: FunctionComponent = () => {
  const { isExpanded } = useContext(ArticleTextboxContext)

  return <FadeOverlay isExpanded={isExpanded} />
}

export default TextboxFadeOverlay
